module.exports = __webpack_public_path__ + "img/10.98e4279b.webp";